import Reveal from '@/components/base/Reveal';

const requirements = [
  {
    icon: 'ri-window-line',
    title: 'MetaTrader 5 terminal',
    detail: 'The platform the EA is built to run on, installed on your machine.',
  },
  {
    icon: 'ri-bank-card-line',
    title: 'A funded trading account',
    detail: 'An MT5 account with the XAUUSD symbol available in Market Watch.',
  },
  {
    icon: 'ri-robot-2-line',
    title: 'Algorithmic trading allowed',
    detail: 'Automated trading must be permitted on your account and terminal.',
  },
  {
    icon: 'ri-plug-line',
    title: 'A stable, always-on connection',
    detail: 'Keep the terminal running so the EA can operate continuously.',
  },
  {
    icon: 'ri-folder-download-line',
    title: 'Your EA files & settings',
    detail: 'The EA files and configuration supplied with your delivery.',
  },
];

function RequirementsBand() {
  return (
    <section className="w-full border-y border-background-200 bg-background-100 px-4 md:px-8 lg:px-12 py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 lg:grid-cols-[40fr_60fr] gap-10 lg:gap-16 items-start">
        <Reveal>
          <div className="lg:sticky lg:top-[110px]">
            <span className="text-[11px] font-data tracking-[0.24em] text-primary-600">
              BEFORE YOU START
            </span>
            <h2 className="mt-5 font-heading font-extrabold tracking-tight text-foreground-950 text-[30px] leading-[1.1] sm:text-[40px] lg:text-[46px]">
              What You Need In Place.
            </h2>
            <p className="mt-5 text-[15px] leading-relaxed text-foreground-600 max-w-[440px]">
              A short checklist before running through the three steps. Nothing here is unusual for
              a MetaTrader Expert Advisor — it is the standard environment the system expects.
            </p>
          </div>
        </Reveal>

        <div className="w-full">
          <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
            {requirements.map((req, idx) => (
              <Reveal key={req.title} delay={idx * 70}>
                <div className="flex items-start gap-4 px-5 md:px-6 py-5 border-b border-background-200 last:border-b-0">
                  <span className="w-10 h-10 shrink-0 rounded-lg bg-background-100 border border-background-200 flex items-center justify-center">
                    <i className={`${req.icon} text-[18px] text-primary-700`}></i>
                  </span>
                  <div className="pt-0.5">
                    <h3 className="font-heading font-bold tracking-tight text-foreground-950 text-[15px]">
                      {req.title}
                    </h3>
                    <p className="mt-1.5 text-[13px] leading-relaxed text-foreground-600">
                      {req.detail}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default RequirementsBand;